import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getPurchaseOrderById,
  updatePurchaseOrder,
} from "../../services/api/boq/purchaseService";
import { fetchProjectsApi } from "../../services/api/boq/projectService";
import { getVendors } from "../../services/api/boq/VendorService";
import { fetchClientsApi } from "../../services/api/boq/clientService";
import {
  fetchBoqByProject,
  fetchBoqById,
} from "../../services/api/boq/boqService";
import { Trash2, ArrowLeft, Save } from "lucide-react";
import toast from "react-hot-toast";

export default function PurchaseOrderEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    po_number: "",
    order_date: "",
    vendor_id: "",
    project_id: "",
    boq_id: "",
    deliver_to: "",
    delivery_date: "",
    notes: "",
    t_c: "",
  });

  const [addedItems, setAddedItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [boqs, setBoqs] = useState([]);

  useEffect(() => {
    const initData = async () => {
      try {
        setLoading(true);

        const [projRes, vendRes, clientRes, poData] = await Promise.all([
          fetchProjectsApi(),
          getVendors(),
          fetchClientsApi(),
          getPurchaseOrderById(id),
        ]);

        const currentPo = poData.data;

        // if (currentPo.project_id) {
        //   const boqList = await fetchBoqByProject(currentPo.project_id);
        //   setBoqs(boqList || []);
        // }
        if (currentPo.project_id) {
          const res = await fetchBoqByProject(currentPo.project_id);
          setBoqs(res.data || res || []);
        }
        setProjects(projRes?.data?.data?.data || []);
        setVendors(vendRes?.data?.data?.data || []);
        setClients(clientRes?.data || []);

        // setFormData({
        //   po_number: poData.data.po_number,
        //   order_date: poData.data.order_date,
        //   client_id: poData.data.client_id ? String(poData.data.client_id) : "",
        //   vendor_id: poData.data.vendor_id,
        //   project_id: poData.data.project_id,
        //   boq_id: currentPo.boq_id ? String(currentPo.boq_id) : "",
        //   deliver_to: poData.data.deliver_to || "",
        //   delivery_date: poData.data.delivery_date || "",
        //   notes: poData.data.notes || "",
        //   t_c: poData.data.t_c || "",
        // });
        setFormData({
          po_number: currentPo.po_number,
          order_date: currentPo.order_date,
          client_id: currentPo.client_id ? String(currentPo.client_id) : "",
          vendor_id: currentPo.vendor_id ? String(currentPo.vendor_id) : "",
          project_id: currentPo.project_id ? String(currentPo.project_id) : "",
          boq_id: currentPo.boq_id ? String(currentPo.boq_id) : "All",
          deliver_to: currentPo.deliver_to || "",
          delivery_date: currentPo.delivery_date || "",
          notes: currentPo.notes || "",
          t_c: currentPo.t_c || "",
        });

        //setAddedItems(poData.data.items || []);
        setAddedItems(currentPo.items || []);
      } catch (error) {
        toast.error("Failed to load purchase order details");
      } finally {
        setLoading(false);
      }
    };

    initData();
  }, [id]);

  // Handle manual project change
  const handleProjectChange = async (e) => {
    const newProjectId = e.target.value;
    setFormData((prev) => ({ ...prev, project_id: newProjectId, boq_id: "" }));

    if (newProjectId) {
      const boqList = await fetchBoqByProject(newProjectId); //
      setBoqs(boqList || []);
    } else {
      setBoqs([]);
    }
  };

  const handleBoqChange = async (e) => {
    //const selectedBoqId = e.target.value;
    // setFormData((prev) => ({ ...prev, boq_id: selectedBoqId }));
    const val = e.target.value;
    setFormData((prev) => ({ ...prev, boq_id: val }));

    // if (!selectedBoqId || selectedBoqId === "all") {
    //   // setAddedItems([]);
    //   return;
    // }
    if (val === "all" || !val) {
      return;
    }
    try {
      //const res = await fetchBoqById(selectedBoqId); //
      const res = await fetchBoqById(val);
      const boqData = res.data;
      const extractedName = boqData?.boq?.boq_name || "";
      // 3. Update the boq_name in formData state
      setFormData((prev) => ({
        ...prev,
        boq_name: extractedName,
      }));
      const newItems = (boqData.items || []).map((item) => ({
        id: Date.now() + Math.random(),
        boq_item_id: item.id || item.boq_id,
        item_name: item.item_name,
        description: item.description,
        quantity: item.quantity,
        unit: item.unit,
        unit_price: item.unit_price,
        ordered_qty: 0,
        total: 0,
        is_manual: 0,
      }));

      setAddedItems(newItems);
    } catch (error) {
      toast.error("no items for the selected BOQ");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // --- START COPIED FUNCTIONALITY FROM CREATE PAGE ---

  const handleAddManualItem = () => {
    const newItem = {
      id: Date.now(),
      boq_item_id: null,
      item_name: "",
      description: "",
      quantity: 0,
      unit: "",
      unit_price: 0,
      ordered_qty: 0,
      total: 0,
      deliver_to: "",
      is_manual: 1,
      is_new: true,
      is_billable: 1,
    };

    setAddedItems((prev) => [newItem, ...prev]);
  };

  const updateItem = (id, updates) => {
    setAddedItems((prev) => {
      return prev.map((item) => {
        if (item.id !== id) return item;

        const updated = { ...item, ...updates };

        // auto total calculation exactly like Create page
        const qty = Number(updated.ordered_qty || 0);
        const rate = Number(updated.unit_price || 0);
        updated.total = qty * rate;

        return updated;
      });
    });
  };

  // --- END COPIED FUNCTIONALITY ---

  const removeItem = (index) => {
    setAddedItems(addedItems.filter((_, i) => i !== index));
  };

  const calculateGrandTotal = () =>
    addedItems.reduce((sum, item) => sum + (parseFloat(item.total) || 0), 0);

  const handleSave = async () => {
    const toastId = toast.loading("Updating Purchase Order...");
    try {
      const payload = {
        po_number: formData.po_number,
        vendor_id: formData.vendor_id,
        project_id: formData.project_id,
        client_id: formData.client_id,
        order_date: formData.order_date,
        delivery_date: formData.delivery_date,
        deliver_to: formData.deliver_to,
        notes: formData.notes,
        t_c: formData.t_c,
        total_amount: calculateGrandTotal(),
        items: addedItems.map((item) => ({
          // Use the actual ID if it's from the DB, else null for new items
          id:
            typeof item.id === "number" && item.id > 999999999 ? null : item.id,
          item_name: item.item_name,
          boq_item_id: item.boq_item_id || null,
          is_manual: item.is_manual ? 1 : 0,
          unit_price: parseFloat(item.unit_price) || 0,
          ordered_qty: parseFloat(item.ordered_qty) || 0,
          total: parseFloat(item.total) || 0,
          is_billable: item.is_billable ?? 1,
        })),
      };

      // Use the 'result' here to verify success
      const result = await updatePurchaseOrder(id, payload);

      // If the backend returns a success message, use it
      if (result) {
        toast.success(
          result.message || "Purchase Order updated successfully!",
          { id: toastId },
        );
        navigate("/purchase-orders");
      }
    } catch (error) {
      console.error("Update Error:", error);
      toast.error("Failed to update PO");
    }
  };

  if (loading) return <div className="p-10 text-center">Loading Data...</div>;

  return (
    <div className="p-4 max-w-5xl mx-auto">
      {/* HEADER (MATCH CREATE STYLE) */}
      <div className="flex justify-between items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-600 flex items-center gap-2"
        >
          <ArrowLeft size={18} /> Back
        </button>

        <h2 className="text-xl font-bold">Edit Purchase Order</h2>

        <button
          onClick={handleSave}
          className="bg-blue-600 text-white px-4 py-2 rounded flex items-center gap-2"
        >
          <Save size={16} /> Update
        </button>
      </div>

      {/* FORM SECTION (MATCH CREATE UI GRID STYLE) */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">PO Number</label>
          <input
            name="po_number"
            value={formData.po_number}
            disabled
            className="border px-3 py-2 rounded bg-gray-100"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">PO Date</label>
          <input
            type="date"
            name="order_date"
            value={formData.order_date}
            onChange={handleInputChange}
            className="border px-3 py-2 rounded"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">Client</label>
          <select
            name="client_id"
            value={formData.client_id} // This links to the state we just set
            onChange={handleInputChange}
            className="border px-3 py-2 rounded"
          >
            <option value="">Select Client</option>
            {clients.map((c) => (
              <option key={c.id} value={String(c.id)}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">Vendor</label>
          <select
            name="vendor_id"
            value={formData.vendor_id}
            onChange={handleInputChange}
            className="border px-3 py-2 rounded"
          >
            {vendors.map((v) => (
              <option key={v.id} value={v.id}>
                {v.name}
              </option>
            ))}
          </select>
        </div>
        {/* <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">Project</label>
          <select
            name="project_id"
            value={formData.project_id}
            onChange={handleInputChange}
            className="border px-3 py-2 rounded"
          >
            {projects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.project_name}
              </option>
            ))}
          </select>
        </div> */}
        {/* Project Select */}
        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">Project</label>
          <select
            name="project_id"
            value={formData.project_id}
            onChange={handleProjectChange}
            className="border px-3 py-2 rounded"
          >
            <option value="">Select Project</option>
            {projects.map((p) => (
              <option key={p.id} value={String(p.id)}>
                {p.project_name}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">BOQ</label>
          <select
            name="boq_id"
            value={formData.boq_id}
            onChange={handleBoqChange}
            className="border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="all">All</option>

            {boqs.map((boq) => (
              <option key={boq.id} value={String(boq.id)}>
                {boq.boq_name}
              </option>
            ))}
          </select>
        </div>
        {/* <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">BOQ</label>
          <input
            list="boq-options"
            name="boq_id"
            // We find the name for the ID to show the user-friendly text in the input
            value={
              formData.boq_id === "all"
                ? "All"
                : boqs.find((b) => String(b.boq_id) === formData.boq_id)
                    ?.boq_name || formData.boq_id
            }
            onChange={(e) => {
              // Find if the typed name matches a BOQ ID
              const selected = boqs.find((b) => b.boq_name === e.target.value);
              const val =
                e.target.value === "All"
                  ? "all"
                  : selected
                    ? String(selected.boq_id)
                    : e.target.value;

              // Trigger your existing change logic
              handleBoqChange({ target: { name: "boq_id", value: val } });
            }}
            className="border px-3 py-2 rounded focus:ring-2 focus:ring-blue-500"
            placeholder="Type or select BOQ"
            autoComplete="off"
          />

          <datalist id="boq-options">
            <option value="All" />
            {boqs.map((boq) => (
              <option key={boq.boq_id} value={boq.boq_name} />
            ))}
          </datalist>
        </div> */}
        <div className="md:col-span-2 flex flex-col gap-1">
          <label className="text-sm font-semibold">Delivery Address</label>
          <input
            name="deliver_to"
            value={formData.deliver_to}
            onChange={handleInputChange}
            className="border px-3 py-2 rounded"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm font-semibold">Delivery Date</label>
          <input
            type="date"
            name="delivery_date"
            value={formData.delivery_date}
            onChange={handleInputChange}
            className="border px-3 py-2 rounded"
          />
        </div>
      </div>

      <div className="flex justify-between items-center mt-6 mb-2">
        {/* <h3 className="font-semibold">Items</h3> */}
        {/* ADD MANUAL ITEM BUTTON COPIED FROM CREATE PAGE */}
        <button
          type="button"
          onClick={handleAddManualItem}
          className="bg-green-600 text-white px-3 py-1.5 rounded text-sm"
        >
          + Add Manual Item
        </button>
      </div>

      {/* ITEMS TABLE (STYLE MATCHED TO CREATE PAGE) */}
      <h3 className="font-semibold mt-6 mb-2">Items</h3>

      <div className="overflow-x-auto border rounded-lg bg-white">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3">#</th>
              <th className="p-3">Item</th>
              <th className="p-3">Qty</th>
              <th className="p-3">Rate</th>
              <th className="p-3">Total</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>

          {/* <tbody>
            {addedItems.map((item, index) => (
              <tr key={index} className="border-t hover:bg-gray-50">
                <td className="p-3">{index + 1}</td>
                <td className="p-3">{item.item_name}</td>
                <td className="p-3 text-center">{item.ordered_qty}</td>
                <td className="p-3 text-right">₹{item.unit_price}</td>
                <td className="p-3 text-right font-bold">₹{item.total}</td>
                <td className="p-3 text-center">
                  <button onClick={() => removeItem(index)}>
                    <Trash2 size={16} className="text-red-500" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody> */}
          <tbody>
            {addedItems.map((item, index) => (
              <tr
                key={item.id || index}
                className={`border-t hover:bg-gray-50 ${item.is_new ? "bg-yellow-50" : ""}`}
              >
                <td className="p-3">{index + 1}</td>
                <td className="p-3">
                  {item.is_manual ? (
                    <input
                      type="text"
                      className="border p-1 w-full rounded"
                      value={item.item_name}
                      onChange={(e) =>
                        updateItem(item.id, { item_name: e.target.value })
                      }
                    />
                  ) : (
                    item.item_name
                  )}
                </td>
                <td className="p-3 text-center">
                  <input
                    type="number"
                    className="border p-1 w-20 rounded text-center"
                    value={item.ordered_qty}
                    onChange={(e) =>
                      updateItem(item.id, {
                        ordered_qty: Number(e.target.value),
                      })
                    }
                  />
                </td>
                <td className="p-3 text-right">
                  <div className="flex items-center justify-end gap-1">
                    <span>₹</span>
                    <input
                      type="number"
                      className="border p-1 w-24 rounded text-right"
                      value={item.unit_price}
                      onChange={(e) =>
                        updateItem(item.id, {
                          unit_price: Number(e.target.value),
                        })
                      }
                    />
                  </div>
                </td>
                <td className="p-3 text-right font-bold">₹{item.total}</td>
                <td className="p-3 text-center">
                  <button onClick={() => removeItem(index)}>
                    <Trash2 size={16} className="text-red-500" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="p-3 text-right font-bold bg-gray-50">
          Grand Total: ₹{calculateGrandTotal()}
        </div>
      </div>

      {/* NOTES SECTION */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <div className="bg-white p-4 border rounded-xl">
          <label className="font-medium">Terms & Conditions</label>
          <textarea
            name="t_c"
            value={formData.t_c}
            onChange={handleInputChange}
            rows={3}
            className="w-full border mt-2 p-2 rounded"
          />
        </div>

        <div className="bg-white p-4 border rounded-xl">
          <label className="font-medium">Notes</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleInputChange}
            rows={3}
            className="w-full border mt-2 p-2 rounded"
          />
        </div>
      </div>
    </div>
  );
}
